import { render, staticRenderFns } from "./Retpassword.vue?vue&type=template&id=d3974a00&scoped=true&"
import script from "./Retpassword.vue?vue&type=script&lang=js&"
export * from "./Retpassword.vue?vue&type=script&lang=js&"
import style0 from "./Retpassword.vue?vue&type=style&index=0&id=d3974a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3974a00",
  null
  
)

export default component.exports